import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'

type Props = {
  title: string
}

const CardTitle: FC<Props> = React.memo((props) => {
  const { title } = props
  return <h2 className={styles.title}>{title}</h2>
})

export default CardTitle
